import { bl_fi_stmt_account_template_sales_agents_filter_RowClass } from '../../../dbschema/bl_fi_stmt_account_template_sales_agents_filter.model';
import { BaseContainerModel } from '../../base-container.model';

export class StatementOfAccountTemplateSalesAgentsFilterModel extends BaseContainerModel {
  bl_fi_stmt_account_template_sales_agents_filter: bl_fi_stmt_account_template_sales_agents_filter_RowClass = new bl_fi_stmt_account_template_sales_agents_filter_RowClass();
}

